import { Tooltip, type TooltipProps } from 'recharts';

const SERIES_LABELS: Record<string, string> = {
  value: 'Cantidad',
  count: 'Cantidad',
};

export function translateChartSeriesLabel(name: string | number | undefined): string | number {
  if (typeof name !== 'string') return name ?? '';
  return SERIES_LABELS[name] ?? name;
}

const defaultContentStyle = {
  backgroundColor: 'hsl(var(--card))',
  borderColor: 'hsl(var(--border))',
  borderRadius: '8px',
};

type SpanishTooltipProps = TooltipProps<number, string>;

export function SpanishTooltip({ formatter, contentStyle, ...props }: SpanishTooltipProps) {
  return (
    <Tooltip
      contentStyle={{ ...defaultContentStyle, ...contentStyle }}
      formatter={
        formatter ??
        ((value, name) => [value, translateChartSeriesLabel(name)])
      }
      {...props}
    />
  );
}
